<ng-template #rowActions let-company>
  <action-menu [items]="actionMenuItems" (clickAction)="actions[$event.valueOf()].emit(company)" [actionData]="company"></action-menu>
  <!-- <a
    mat-icon-button
    [routerLink]="['/companies', company.id]"
    aria-label="Detail"
    matTooltip="Detail"
  >
    <mat-icon>visibility</mat-icon>
  </a>

  @if ((company.isActive && canDeactivate()) || (!company.isActive && canActivate())) {
    <button
      mat-icon-button
      type="button"
      [disabled]="actionCompanyId() === company.id"
      (click)="toggled.emit(company)"
      [attr.aria-label]="company.isActive ? 'Deactivate' : 'Activate'"
      [matTooltip]="company.isActive ? 'Deactivate' : 'Activate'"
    >
      @if (actionCompanyId() === company.id) {
        <mat-spinner diameter="18" />
      } @else {
        <mat-icon>
          {{ company.isActive ? 'block' : 'check_circle' }}
        </mat-icon>
      }
    </button>
  } -->
</ng-template>

<data-table
  title="Companies"
  loadingMessage="Loading companies..."
  emptyMessage="No companies found."
  [rows]="companies()"
  [columns]="columns"
  [actionsTemplate]="rowActions"
  [loading]="loading()" />